import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import { CreditBalance } from "./Balance";
import { Payment } from "./payment";
import { Text, ToastMessage } from "components/common";
import { LoadingLayout, PageLayout } from "components";
import { WalletIcon } from "components/icons";
import { BillingTitleStyle, WalletIconStyle } from "features/settings/styles";
import axios from "axios";
import { extractFromQuery } from "utils/helpers";
import { usePageViewed, useSubscriptionPlan } from "hooks";
import { EActivityEvent } from "types";

type Params = {
  success: string;
  canceled?: string;
  error?: string;
};

const Div = styled.div`
  max-width: 720px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (max-width: 765px) {
    align-items: center;
  }
`;
export const ManageBillingScreen: React.FC = () => {
  const [normalPrice, setNormalPrice] = useState<number>(0);
  const [discountPrice, setDiscountPrice] = useState<number>(0);
  const [showToast, setShowToast] = useState(false);
  const [success, setSuccess] = useState(false);

  usePageViewed(EActivityEvent.BillingPageViewed);

  //const { data: subscriptionData, loading } =
  //  useQuery<SubscriptionResponse>(CURRENT_SUBSCRIPTION);

  const { loading, vipUser, stripeCustomerId, creditBalance, ...subscription } =
    useSubscriptionPlan();

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const { success, canceled, error } = extractFromQuery<Params>(
      window.location.search,
    );

    if (success) {
      // show success message
      setSuccess(true);
      setShowToast(true);
    } else if (canceled) {
      // show cancel message
      setShowToast(true);
      setSuccess(false);
    } else if (error) {
      // show error message
      setShowToast(true);
      setSuccess(false);
    }

    // remove query params
    setTimeout(() => {
      window.history.replaceState({}, document.title, window.location.pathname);
    }, 3000);
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/billing/get-credit-cost`)
      .then((res) => {
        setNormalPrice((res.data?.normalPrice || 0) / 100);
        setDiscountPrice((res.data?.annualDiscountPrice || 0) / 100);
      })
      .catch();
  }, []);

  //const currentSubscription = subscription
  //  ? {
  //      name: subscription?.plan,
  //      expireIn: new Date(subscription?.endAt || Date.now()),
  //      isTrial: subscription?.isTrial,
  //      startAt: userState?.firstSubscriptionAt,
  //      billingCycle: subscription?.billingCycle,
  //    }
  //  : {
  //      name: "Free",
  //      expireIn: new Date(),
  //      isTrial: false,
  //      startAt: undefined,
  //      billingCycle: undefined,
  //    };

  if (loading) {
    return <LoadingLayout />;
  }

  return (
    <PageLayout title="Billing | Multiplayer">
      <ToastMessage
        show={showToast}
        handleShow={setShowToast}
        success={success}
      />
      <Div>
        <div className={BillingTitleStyle}>
          <WalletIcon style={WalletIconStyle} fill="primary" />
          <Text.H3>Plan & Billing</Text.H3>
        </div>
        <Payment
          currentPlan={subscription}
          pricing={{ normalPrice, discountPrice }}
          vipUser={vipUser}
        />
        <CreditBalance
          balance={creditBalance || 0}
          currentPlan={subscription}
          stripeCustomerId={stripeCustomerId}
          pricing={{ normalPrice, discountPrice }}
          vipUser={vipUser}
        />
      </Div>
    </PageLayout>
  );
};
